import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

const PersonalInfo = ({ data }) => (
  <Table borderless border="0" cellSpacing="0" cellPadding="0">
    <thead>
      <tr>
        <th colSpan="2">
          <div className="pagination-container">
            <h5>Contact</h5>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td />
        <td>
          <span className="subheader">Agency:</span>
          <span>{data.agency?.legalName}</span>
          <span className="subheader">Legal Name:</span>
          <span>{data.legalname}</span>
          <span className="subheader">Business Email:</span>
          <span className="text-transform-none">{data.email}</span>
          <span className="subheader">Business Phone:</span>
          <span>{data.phone}</span>
          <span className="subheader">Business Fax:</span>
          <span>{data.fax}</span>
          <span className="subheader">Clinic CallerID:</span>
          <span>{data.callerId}</span>
          <span className="subheader">CRM ID:</span>
          <span>{data.crmId}</span>
        </td>
      </tr>
    </tbody>
  </Table>
);

PersonalInfo.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default PersonalInfo;
